import './table.component.scss';
import { ReactNode } from 'react';

export interface TableProps {
    className?: string;
    children: ReactNode;
}

const Table = ({ className, children }: TableProps) => (
    <div className={`table ${className || ''}`}>{children}</div>
);

export default Table;

export enum SortDirection {
    None,
    Asc,
    Desc
}
